export const promotionTypes = {
  FIXED_AMOUNT: 'fixed_amount',
  PERCENT_AMOUNT: 'percent_amount',
  FREE_SHIPPING: 'free_shipping',
  FREE_DELIVERY: 'free_delivery',
  FREE_ITEM: 'free_item',
  SPECIAL_ITEM_PRICING: 'special_item_pricing'
};

export const promotionTypeOptions = [
  promotionTypes.FIXED_AMOUNT,
  promotionTypes.PERCENT_AMOUNT,
  promotionTypes.FREE_SHIPPING,
  promotionTypes.FREE_DELIVERY,
  promotionTypes.FREE_ITEM,
  promotionTypes.SPECIAL_ITEM_PRICING
];

export const QUALIFYING_ITEMS = 'qualifying_items';

export const PERCENT = 'percent';
